import styled from "styled-components";

export const ModalContent = styled.div`
  overflow: scroll;
  background-color: #fff;
  padding: 2rem;

  @media (max-width: 769px) {
    padding: 1rem 0;
    text-align- center
  }
`;

export const Title = styled.h1`
  display: grid;
  color: #4181f8;
  font-size: 1.5rem;

  span {
    text-align: left;
  }

  @media (max-width: 769px) {
    padding: 1rem 0;

    span {
      text-align: center;
    }
  }
`;

export const ButtonArea = styled.div`
  display: flex;
  justify-content: right;
  align-items: right;
  flex-direction: row;

  @media (max-width: 769px) {
    justify-content: center;
    align-items: center;
  }
`;

export const Button = styled.div`
  width: 33%;
  height: 40px;
  margin-top: 15px;
  margin-left: 1px;
  background: #000FFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #0000004d;
  outline: none !important;
  border: 0;
  border-radius: 7px;
  cursor: pointer;
  transition: 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none !important;
  padding: 1px;
  color: #ffffff;
  &:hover {
    filter: brightness(90%);
  }
  span {
    color: #ffffff;
  }
  @media (max-width: 769px) {
    width: 100%;
  }
  @media (min-width: 855px) and (max-width: 975px) {
    font-size: 0.9rem;
  }
`;